import cn from 'classnames';
import Link from 'next/link';
import { FC, PropsWithChildren } from 'react';
import { useRootStore } from 'stores/use-root-store';
import { PetType } from 'constants/pet-type';

interface IPrimaryLinkProps {
  href: string;
  petContextAware: PetType | undefined;
  title: string;
  onClick: () => void;
}

const PrimaryLink: FC<PropsWithChildren<IPrimaryLinkProps>> = ({
  children,
  href,
  petContextAware,
  title,
  onClick,
}) => {
  const petType = useRootStore((store) => store.petType);

  return (
    <Link
      href={href}
      passHref
      data-test={`nav-${petContextAware}-${title}`}
      className={cn(
        'border-primary-main flex h-14 min-w-22.5 items-center justify-center self-end rounded-t-lg border-r px-4 pt-3.5 pb-3 text-lg font-black last:border-r-0',
        petContextAware === petType
          ? 'bg-other-white text-primary-main'
          : 'text-text-dark-bg-contrast-white'
      )}
      onClick={() => {
        onClick();
      }}
    >
      {children}
    </Link>
  );
};

export default PrimaryLink;
